/** @jsx jsx */

import PropTypes from "prop-types"
import { jsx, Grid, Input, Label } from "theme-ui"

import { TransformedCrystallizeProductPropTypes } from "../../utils/propTypes"
import { calculateProductCost } from "../../utils/eCommerceUtils"
import { SelectField } from "../SelectField"

export const ProductControls = ({
  product,
  labels,
  selectionState,
  updateSelectionState,
}) => {
  const { quantity, variantSku } = selectionState
  const productOptions = Object.keys(product.variants).reduce(
    (displayedVariants, variantSku) => {
      if (product.variants[variantSku].attributes.shouldDisplay) {
        return [
          ...displayedVariants,
          {
            label: product.variants[variantSku].name,
            value: variantSku,
          },
        ]
      }
      return displayedVariants
    },
    []
  )

  return (
    <Grid as="form" columns={[1, 2]}>
      <div>
        <Label htmlFor="option" variant="labelOlive">
          {labels.option || "Option"}
        </Label>
        <SelectField
          variant="selectOlive"
          name="option"
          id="option"
          options={productOptions}
          value={variantSku}
          onChange={e => {
            const newSku = e.target.value
            updateSelectionState({
              ...selectionState,
              variantSku: newSku,
              cost: calculateProductCost(product, newSku, quantity),
            })
          }}
        />
      </div>
      {!product.variants[variantSku].attributes.nonQuantityVariant ? (
        <div>
          <Label variant="labelOlive" htmlFor="quantity">
            {labels.quantity || "Quantity"}
          </Label>
          <Input
            variant="inputOlive"
            name="quantity"
            id="quantity"
            type="number"
            value={quantity}
            min={1}
            // This is required to prevent a weird FF bug on refresh where the
            // selected value is not reset to the default one, but the previous
            // value seems to be "remembered"
            // https://stackoverflow.com/questions/3858359/how-do-i-reset-to-default-drop-down-list-option-on-refreshf5-in-firefox
            autoComplete="off"
            onChange={e => {
              const newQuantity = e.target.value
              updateSelectionState({
                ...selectionState,
                quantity: newQuantity,
                cost: calculateProductCost(product, variantSku, newQuantity),
              })
            }}
          />
        </div>
      ) : null}
    </Grid>
  )
}
ProductControls.propTypes = {
  product: PropTypes.shape(TransformedCrystallizeProductPropTypes),
  labels: PropTypes.shape({
    option: PropTypes.string,
    quantity: PropTypes.string,
  }),
  selectionState: PropTypes.shape({
    cost: PropTypes.number,
    variantSku: PropTypes.string,
    quantity: PropTypes.number,
  }),
  updateSelectionState: PropTypes.func,
}
